<template>
  <div class="home">
    <accueil/>
    <myContent/>
    <myFooter/>
  </div>
</template>

<script>
// @ is an alias to /src
import accueil from '@/components/accueil.vue';
import myContent from '@/components/content.vue';
import myFooter from '@/components/myFooter.vue';

export default {
  name: 'home',
  components: {
    accueil,
    myContent,
    myFooter,
  }
}
</script>
